import React from 'react';
import { GoogleMap, withGoogleMap, Marker } from 'react-google-maps';
import markerIcon from '../../../images/marker.png';
import { Sede } from '../../../utils/entities/Sede';

const MiniMap = withGoogleMap((props: any) => {
  const sede: Sede = props.sede;

  return (
    <GoogleMap
      center={{
        lat: sede ? sede.coordenadas.coordinates[0] : -34.8833,
        lng: sede ? sede.coordenadas.coordinates[1] : -56.1667,
      }}
      defaultOptions={{
        draggable: false,
        gestureHandling: 'greedy',
        disableDefaultUI: true,
        zoom: 15,
        minZoom: 15,
        maxZoom: 15,
        streetViewControl: false,
        rotateControl: false,
        panControl: false,
        mapTypeControl: false,
        keyboardShortcuts: false,
      }}
    >
      <Marker
        icon={markerIcon}
        position={{
          lat: sede ? sede.coordenadas.coordinates[0] : -34.8833,
          lng: sede ? sede.coordenadas.coordinates[1] : -56.1667,
        }}
      />
    </GoogleMap>
  );
});

export default MiniMap;
